const validHost = /^((www|m).youtube.com|youtu.be)$/;
const validPathname = /^.*\/([a-zA-Z0-9_-]{11})$/;

export default function parseYoutubeURL(_url: string) {
  try {
    const url = new URL(_url);

    const embedId = validPathname.exec(url.pathname)?.[1] || url.searchParams.get('v');

    if (!validHost.test(url.hostname) || !embedId) return null;

    const searchParams = new URLSearchParams();

    url.searchParams.delete('v');
    url.searchParams.delete('list');
    url.searchParams.delete('listType');
    url.searchParams.delete('si');

    url.searchParams.forEach((value, key) => {
      if (key === 't') {
        searchParams.append('start', value.endsWith('s') ? value.slice(0, -1) : value);
      } else {
        searchParams.append(key, value);
      }
    });

    searchParams.append('autoplay', '1');

    if (searchParams.toString() !== '') {
      return `https://www.youtube.com/embed/${embedId}?${searchParams.toString()}`;
    }

    return `https://www.youtube.com/embed/${embedId}`;
  } catch (e) {
    return null;
  }
}
